/* Simple Pimple v2: carousel, tickers, vine, night to morning story, sideways gallery, hero motion, reveals. */
(function () {
  document.documentElement.classList.add('js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

  /* reveals and counters */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.remove('below'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  var co = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return; co.unobserve(e.target);
      var el = e.target, to = +el.getAttribute('data-count'), from = +(el.getAttribute('data-from') || 0), t0 = performance.now();
      (function step(t) { var k = clamp((t - t0) / 1400, 0, 1), ease = 1 - Math.pow(1 - k, 3); el.textContent = Math.round(from + (to - from) * ease); if (k < 1) requestAnimationFrame(step); })(t0);
    });
  }, { threshold: 0.6 }) : null;
  function initReveals(root) {
    if (reduce || !io) return;
    var vh = window.innerHeight;
    $$('[data-reveal]', root).forEach(function (el, i) {
      if (el.getBoundingClientRect().top > vh) { el.classList.add('below'); el.style.transitionDelay = (i % 3) * 80 + 'ms'; io.observe(el); }
    });
    $$('[data-count]', root).forEach(function (el) { co.observe(el); });
  }

  /* rotating banners */
  function initCarousel(car) {
    if (car._sp) return; car._sp = true;
    var slides = $$('.sp-slide', car), dotsWrap = car.querySelector('.sp-dots'), dur = (+car.getAttribute('data-duration') || 6) * 1000, cur = 0, timer = null;
    if (slides.length < 2) { car.classList.add('ready'); if (slides[0]) slides[0].classList.add('on'); return; }
    slides.forEach(function (_, i) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Go to slide ' + (i + 1)); b.innerHTML = '<i></i>';
      b.style.setProperty('--dur', dur + 'ms'); b.addEventListener('click', function () { go(i); }); dotsWrap.appendChild(b);
    });
    var dots = $$('button', dotsWrap);
    function restart() { clearTimeout(timer); if (!reduce) timer = setTimeout(function () { go(cur + 1); }, dur); }
    function go(i) {
      slides[cur].classList.remove('on'); cur = (i + slides.length) % slides.length; slides[cur].classList.add('on');
      dots.forEach(function (d, k) { d.classList.toggle('done', k < cur); d.classList.remove('on'); });
      void dots[cur].offsetWidth; dots[cur].classList.add(reduce ? 'done' : 'on'); restart();
    }
    var prev = car.querySelector('[data-prev]'), next = car.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    car.addEventListener('mouseenter', function () { clearTimeout(timer); var i = dots[cur].querySelector('i'); if (i) i.style.animationPlayState = 'paused'; });
    car.addEventListener('mouseleave', function () { var i = dots[cur].querySelector('i'); if (i) i.style.animationPlayState = 'running'; restart(); });
    car.classList.add('ready'); go(0);
  }

  /* vine */
  function initVine(sec) {
    var svg = sec.querySelector('.sp-vine'), stem = svg && svg.querySelector('.stem');
    if (!stem || sec._vine) return;
    var len = stem.getTotalLength(), leaves = [];
    stem.style.strokeDasharray = len; stem.style.strokeDashoffset = reduce ? 0 : len;
    [0.08, 0.2, 0.33, 0.46, 0.6, 0.73, 0.86, 0.96].forEach(function (f, i) {
      var p = stem.getPointAtLength(len * f), g = document.createElementNS('http://www.w3.org/2000/svg', 'g'), s = i % 2 ? -1 : 1;
      g.innerHTML = '<path class="vl" d="M0 0 C ' + 10 * s + ' -9, ' + 24 * s + ' -8, ' + 30 * s + ' 0 C ' + 24 * s + ' 8, ' + 10 * s + ' 9, 0 0 Z" fill="' + (i % 3 ? '#5AA674' : '#2E7652') + '"/>';
      g.setAttribute('transform', 'translate(' + p.x + ' ' + p.y + ')'); svg.appendChild(g);
      if (reduce) g.firstChild.classList.add('grown'); leaves.push({ f: f, el: g.firstChild });
    });
    sec._vine = { stem: stem, len: len, leaves: leaves };
  }

  /* stars */
  function initStory(sec) {
    var stars = sec.querySelector('.sp-stars');
    if (stars && !stars.childElementCount) for (var i = 0; i < 70; i++) { var s = document.createElement('i'); s.style.left = Math.random() * 100 + '%'; s.style.top = Math.random() * 70 + '%'; s.style.opacity = 0.3 + Math.random() * 0.6; stars.appendChild(s); }
  }

  var tickers = [];
  function initTicker(t) {
    if (t._sp) return; t._sp = true;
    $$('.row', t).forEach(function (row, i) { tickers.push({ row: row, x: i % 2 ? -600 : 0, dir: i % 2 ? 1 : -1 }); });
  }

  function initAll(root) {
    $$('[data-carousel]', root).forEach(initCarousel);
    $$('[data-vine]', root).forEach(initVine);
    $$('[data-story]', root).forEach(initStory);
    $$('[data-ticker]', root).forEach(initTicker);
    initReveals(root);
    frame();
  }

  /* scroll driven scenes */
  var night = [14, 36, 25], dawn = [233, 214, 190], day = [231, 241, 235], lastY = window.scrollY, vel = 0, ticking = false;
  function mix(a, b, k) { return a.map(function (v, i) { return Math.round(v + (b[i] - v) * k); }); }
  /* each color holds while its step is on screen, then changes quickly: night, twilight, dawn, morning */
  var twilight = [52, 84, 78];
  var SKY = [[0, night], [0.22, night], [0.31, twilight], [0.40, dawn], [0.60, dawn], [0.76, day], [1, day]];
  function skyAt(p) { for (var i = 1; i < SKY.length; i++) { if (p <= SKY[i][0]) { var a = SKY[i - 1], b = SKY[i], k = (p - a[0]) / Math.max(0.0001, b[0] - a[0]); return mix(a[1], b[1], k); } } return day; }
  function frame() {
    ticking = false;
    var y = window.scrollY, vh = window.innerHeight, W = window.innerWidth;
    vel = vel * 0.85 + (y - lastY) * 0.15; lastY = y;
    if (reduce) return;
    $$('[data-hero-box]').forEach(function (b) { b.style.transform = 'translate(-50%, calc(-52% + ' + y * 0.18 + 'px)) rotate(' + y * 0.02 + 'deg)'; });
    $$('[data-spin]').forEach(function (b) { b.style.transform = 'rotate(' + y * 0.25 + 'deg)'; });
    $$('[data-vine]').forEach(function (sec) {
      var v = sec._vine; if (!v) return;
      var r = sec.getBoundingClientRect(), p = clamp((vh * 0.75 - r.top) / (r.height * 0.9), 0, 1);
      v.stem.style.strokeDashoffset = v.len * (1 - p);
      v.leaves.forEach(function (l) { l.el.classList.toggle('grown', p >= l.f); });
    });
    $$('[data-story]').forEach(function (sec) {
      var pin = sec.querySelector('.pin'), r = sec.getBoundingClientRect(), sp = clamp(-r.top / Math.max(1, r.height - vh), 0, 1);
      var col = skyAt(sp);
      pin.style.background = 'rgb(' + col.join(',') + ')';
      pin.style.color = (0.299 * col[0] + 0.587 * col[1] + 0.114 * col[2]) / 255 > 0.55 ? '#1C4D36' : '#E7F1EB';
      var stars = sec.querySelector('.sp-stars'); if (stars) stars.style.opacity = 1 - clamp(sp / 0.45, 0, 1);
      function arc(k) { var top = window.innerWidth < 900 ? 13 : 20, lift = window.innerWidth < 900 ? 5 : 11; return { x: 6 + k * 80, y: top - Math.sin(k * Math.PI) * lift }; }
      var moon = sec.querySelector('.moon'), sun = sec.querySelector('.sun'), m = arc(clamp(sp / 0.55, 0, 1)), s = arc(clamp((sp - 0.4) / 0.6, 0, 1));
      if (moon) { moon.style.left = m.x + '%'; moon.style.top = m.y + '%'; moon.style.opacity = 1 - clamp((sp - 0.35) / 0.2, 0, 1); }
      if (sun) { sun.style.left = s.x + '%'; sun.style.top = s.y + '%'; sun.style.opacity = clamp((sp - 0.4) / 0.2, 0, 1); }
      var steps = $$('.sp-step', sec), n = Math.max(1, steps.length), idx = Math.min(n - 1, Math.floor(sp * n * 0.999));
      steps.forEach(function (st, i) { st.classList.toggle('on', i === idx); });
      $$('.sp-story-media img', sec).forEach(function (im, i) { im.classList.toggle('on', i === idx); });
      $$('.sp-rail i', sec).forEach(function (d, i) { d.classList.toggle('on', i === idx); });
    });
    if (W > 760) $$('[data-hgal]').forEach(function (sec) {
      var track = sec.querySelector('.sp-track'), r = sec.getBoundingClientRect(), p = clamp(-r.top / Math.max(1, r.height - vh), 0, 1);
      track.style.transform = 'translateX(' + (-p * Math.max(0, track.scrollWidth - W)) + 'px)';
    });
  }
  function loop() {
    if (!reduce) {
      var sp = 0.6 + Math.min(6, Math.abs(vel) * 0.08);
      tickers.forEach(function (t) {
        var w = t.row.scrollWidth / 2; t.x += sp * t.dir;
        if (t.dir < 0 && -t.x >= w) t.x += w; if (t.dir > 0 && t.x >= 0) t.x -= w;
        t.row.style.transform = 'translateX(' + t.x + 'px)';
      });
      vel *= 0.96;
    }
    requestAnimationFrame(loop);
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
  window.addEventListener('resize', frame);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); loop(); });
  else { initAll(document); loop(); }
})();
